

import React, { useState } from 'react';
import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Edit, FileCopy, Delete, Save, Close, ShoppingCart, Email } from '@mui/icons-material';
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';

const LoadingIconButton = ({ loading, onClick, icon, title, disabled = false }) => (
  <Tooltip title={title} placement="top">
    <span> {/* Wrapper needed for disabled Tooltip */}
      <IconButton
        aria-label={title.toLowerCase()}
        onClick={onClick}
        disabled={loading || disabled}
        sx={{
          background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
          width: 40,
          height: 40,
          '&:hover': {
            background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
            transform: 'translateY(-2px)',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
          },
          transition: 'all 0.2s ease-in-out',
          boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
          border: '1px solid rgba(255,255,255,0.1)',
          position: 'relative',
        }}
      >
        {loading ? (
          <CircularProgress
            size={24}
            sx={{
              color: '#ffffff',
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px'
            }}
          />
        ) : (
          icon
        )}
      </IconButton>
    </span>
  </Tooltip>
);

const DealDetailButtons = ({
  deal,
  isEditing,
  handleEditToggle,
  handleCloneDeal,
  handleOpenDeleteModal,
  handleSaveChanges,
  handleDiscardChanges,
  handleCreateOrder,
  setIsEditing,
  handleToggleEmailModal,

  // Loading states
  isEditLoading = false,
  isCloneLoading = false,
  isDeleteLoading = false,
  isSaveLoading = false,
  isOrderLoading = false,
  
}) => {
  return (
    <MDBox>
      {!isEditing && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {deal?.stage !== 'Closed Lost' && deal?.stage !== 'Closed Won' && (
            <LoadingIconButton
              loading={isEditLoading}
              onClick={handleEditToggle}
              icon={<Edit sx={{ color: '#ffffff', fontSize: 20 }} />}
              title="Edit Deal"
            />
          )}

          <LoadingIconButton
            onClick={() => handleToggleEmailModal()}
            icon={<Email sx={{ color: '#ffffff', fontSize: 20 }}  />}
            title="Send Email"
          />

          <LoadingIconButton
            loading={isCloneLoading}
            onClick={handleCloneDeal}
            icon={<FileCopy sx={{ color: '#ffffff', fontSize: 20 }} />}
            title="Clone Deal"
          />

          {deal?.stage !== 'Closed Lost' && deal?.stage !== 'Closed Won' && (
            <LoadingIconButton
              loading={isDeleteLoading}
              onClick={handleOpenDeleteModal}
              icon={<Delete sx={{ color: '#ffffff', fontSize: 20 }} />}
              title="Delete Deal"
            />
          )}
        </Box>
      )}

      {/* Edit Mode Buttons */}
      {isEditing && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <MDButton
            variant="contained"
            onClick={handleDiscardChanges}
            disabled={isSaveLoading}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
            startIcon={<Close />}
          >
            Cancel
          </MDButton>

          <MDButton
            variant="contained"
            onClick={handleSaveChanges}
            disabled={isSaveLoading}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
              position: 'relative',
            }}
          >
            {isSaveLoading ? (
              <CircularProgress
                size={24}
                sx={{
                  color: '#ffffff',
                  marginRight: 1
                }}
              />
            ) : (
              <Save sx={{ marginRight: 1 }} />
            )}
            Save
          </MDButton>
        </Box>
      )}
    </MDBox>
  );
};

export default DealDetailButtons;